import "../scss/main.scss";

(function ($) {
  $(document).ready(function () {
    theme.init();
  });

  var theme = {
    init: function () {
      this.headerFunctions();
      this.readMoreLess();
      this.sliders();
      this.scrollTo();
    },

    headerFunctions: function () {
      $(".toggle-nav").click(function (e) {
        e.preventDefault();
        $(".navbar .main-menu-container").fadeToggle();
        $(".icon-bar").toggleClass("toggled");
      });

      $(window).scroll(function(){
        if ($(window).scrollTop() >= 150) {
            $('header').addClass('fixed-header');
        }
        else {
            $('header').removeClass('fixed-header');
        }
    });
    },

    readMoreLess: function () {
      $("#faq a.read-more").click(function (e) {
        e.preventDefault();
        $(this).hide();
        $(this).parent().parent().find('.hidden').fadeIn();
      });

      $("#faq a.read-less").click(function (e) {
        e.preventDefault();
        $(this).parent().hide();
        $(this).parent().parent().parrent().find('a.read-more').fadeIn();
      });
    },

    sliders: function () {
      $('.slider').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });

      $('.actors').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              dots: true,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              dots: true,
            }
          }
        ]
      });

      $('.news').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    },

    scrollTo: function () {
      $( '.scrollTo a' ).on( 'click', function(e) {
        e.preventDefault();
        var href = $( this ).attr( 'href' );
        $( 'html, body' ).animate( { 
          scrollTop: $( href ).offset().top - 100
        }, 1500); 
    } );
    }
  };
})(jQuery);
